export const isStandaloneApp = () =>
  window.matchMedia("(display-mode: standalone)").matches || window.navigator.standalone === true;

export const setAppBadge = (count) => {
  if (!("setAppBadge" in navigator)) return;
  const n = Number(count) || 0;
  (n > 0 ? navigator.setAppBadge(n) : navigator.clearAppBadge()).catch(() => {});
};
